export const tenantGroupsConstants = {
  TENANT_GROUPS_LIST_REQUEST: 'TENANT_GROUPS_LIST_REQUEST',
  TENANT_GROUPS_LIST_SUCCESS: 'TENANT_GROUPS_LIST_SUCCESS',
  TENANT_GROUPS_LIST_FAILURE: 'TENANT_GROUPS_LIST_FAILURE',
  TENANT_GROUPS_LIST_CHANGED: 'TENANT_GROUPS_LIST_CHANGED',
  TENANT_GROUPS_LIST_PAGINATION: 'TENANT_GROUPS_LIST_PAGINATION',

  TENANT_GROUPS_LOAD_REQUEST: 'TENANT_GROUPS_LOAD_REQUEST',
  TENANT_GROUPS_LOAD_SUCCESS: 'TENANT_GROUPS_LOAD_SUCCESS',
  TENANT_GROUPS_LOAD_FAILURE: 'TENANT_GROUPS_LOAD_FAILURE',

  TENANT_GROUPS_SAVE_REQUEST: 'TENANT_GROUPS_SAVE_REQUEST',
  TENANT_GROUPS_SAVE_SUCCESS: 'TENANT_GROUPS_SAVE_SUCCESS',
  TENANT_GROUPS_SAVE_FAILURE: 'TENANT_GROUPS_SAVE_FAILURE',
};
